/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/no-misused-promises */
import React from 'react'
import { WidgetType } from '@enums/WidgetType'
import { onDownloadApp } from '@components/MainWidget/common/helper'
import { APP_CHALLANS, DOWNLOAD_APP_CTA_TEXT } from './constants'
import styles from './whatsappChallan.module.scss'

interface DownloadAppButtonProps {
  regNum: string
  phoneNumber: string
  vehicleData: any
}

const DownloadAppButton: React.FC<DownloadAppButtonProps> = ({ regNum, phoneNumber, vehicleData }) => (
  <div className={styles.downloadButtonContainer}>
    <button
      type="button"
      className={styles.buttonDownload}
      onClick={() =>
        onDownloadApp({
          regNo: regNum,
          widgetType: WidgetType.CHALLAN_WIDGET_LANDING,
          phone: phoneNumber,
          vehicleData,
          ctaText: DOWNLOAD_APP_CTA_TEXT,
        })
      }>
      {APP_CHALLANS}
    </button>
  </div>
)

export default DownloadAppButton
